import { createContext } from "react";

import { getInitialValue, type InitialValue } from "./initialValue.ts";
import type { NodeTransientState, NodeTransientStateHook } from "./types.ts";

export const NodeTransientStateContext = createContext<NodeTransientState>({
  useTransientState: <T, I>(id: number, initialValue: InitialValue<I>): NodeTransientStateHook<T, I> => {
    console.warn("useTransientState called outside of NodeTransientStateProvider");
    return [getInitialValue(initialValue), () => {}];
  },
});

NodeTransientStateContext.displayName = "NodeTransientStateContext";
